import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { IAppState } from '../../store/reducers';
import { AuthState } from '../../store/reducers/auth';

const TOKEN_STORAGE_KEY = 'BYPASS_AUTH_KEY';

interface BypassTokenData {
  token: string;
  id: string;
  type: string;
  roles: string[];
  formType: string;
  patientId: string;
  appointmentId?: string;
  therapyId?: string;
  providerId?: string;
}

export const useBypassToken = () => {
  const [tokenData, setTokenData] = useState<BypassTokenData | null>(null);

  useEffect(() => {
    const storedData = localStorage.getItem(TOKEN_STORAGE_KEY);
    if (storedData) {
      try {
        setTokenData(JSON.parse(storedData));
      } catch (err) {
        console.error('Error parsing stored token data:', err);
        localStorage.removeItem(TOKEN_STORAGE_KEY);
      }
    }
  }, []);

  return {
    ...tokenData,
    isTokenBased: !!tokenData
  };
}; 